$(document).ready(/\/faculty-management\/inventory-item\/\d*\/rental/.test(window.location.pathname)&&function() {
  const showCorrespondingInput = function() {
    const lentTo = $('select[name="lentTo"]').val();
    if (lentTo && lentTo === 'employee') {
      $('select[name="student"]').closest('div[class^="col"]').hide();
      $('select[name="employee"]').closest('div[class^="col"]').show();
    } else {
      $('select[name="employee"]').closest('div[class^="col"]').hide();
      $('select[name="student"]').closest('div[class^="col"]').show();
    }
  };

  const toggleReturnDate = function() {
    const returned = $('select[name="returned"]').val();
    if (returned > 0) {
      $('input[name="returnDate"]').prop('disabled', false);
    } else {
      $('input[name="returnDate"]').prop('disabled', true);
    }
  };

  $('select[name="lentTo"]').on('change', function() {
    showCorrespondingInput();
  });
  $('select[name="returned"]').on('change', function() {
    toggleReturnDate();
  });

  showCorrespondingInput();
  toggleReturnDate();
});
